import { render, staticRenderFns } from "./RecoverFirebase.vue?vue&type=template&id=40c68e21&scoped=true&"
import script from "./RecoverFirebase.vue?vue&type=script&lang=ts&"
export * from "./RecoverFirebase.vue?vue&type=script&lang=ts&"
import style0 from "./RecoverFirebase.vue?vue&type=style&index=0&id=40c68e21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c68e21",
  null
  
)

export default component.exports